var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tabs',{ref:"tabs",attrs:{"columns":_vm.columns,"brokerageType":_vm.brokerageType,"getlistUrl":_vm.getlistUrl},on:{"changeTabsBtn":_vm.changeTabsBtn,"exportForm":function($event){return _vm.$emit('exportForm')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }